export default {
  // Auth endpoints
  login: `/api/users/login/`,
  // logout: `/base/users/logout/`,
  // profile: "/base/users/profile/",
  // forgotPassword: "/base/v1/user/forgot-password/",
  // resetPassword: "/base/v1/user/reset-password/",
  // Other Apis

  getAllProjects: "/api/dashboard/v1/dashboard_query/",
  getStates: "/api/dashboard/v1/classification/",
  getRERAProject: "/api/rera/get_project/",
  getKarnatakaRERAProject: "/api/rera/get_project_karnataka/",
  getLTProject: "/api/rera/get_project_lt/",
  getRecentProjects: "/api/rera/rera_project/",

  processLTDocument: "/api/rera/lt_doc/",
  uploadLTDocument: "/api/rera/lt_doc_upload/",

  getRecentSearches: "/api/rera/get_project_lt/",
  projectSearch: "/api/rera/project-search/",
  downloadProjectCanva: "/api/dashboard/v1/canva-generation/",
  uploadCanvaDocument: "/api/dashboard/v1/canva-pdf-upload/",
};
